import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { SnackService } from 'src/app/services/snack.service';
import { LoadingService } from 'src/app/services/loading.service';
import { Observable } from 'rxjs';
import { _post } from '../../../../../services/base.service';

@Injectable({
  providedIn: 'root',
})
export class ImmoInvoiceSubProjectsControllerRequestService {
  private readonly post: <T>(
    path: string,
    body: any,
    deserialize: (response: any) => T
  ) => Observable<T>;
  private readonly deserialize = (res) => res as SuccessMessage;
  constructor(
    http: HttpClient,
    snackService: SnackService,
    loadingService: LoadingService,
    router: Router
  ) {
    const requestServices = {
      http,
      loadingService,
      router,
      snackService,
    };
    this.post = _post('/immo/invoiceSubProjects', requestServices);
  }

  public invoiceSubProjects(
    subProjectIds: number[],
    companyId: number
  ): Promise<SuccessMessage> {
    const request: InvoiceSubProjectsRequest = {
      subProjectIds: subProjectIds,
      companyId: companyId,
    };
    return this.post('', request, this.deserialize).toPromise();
  }
}

interface InvoiceSubProjectsRequest {
  subProjectIds: number[];
  companyId: number;
}

interface SuccessMessage {
  success: boolean;
  message: string;
}
